import { render, staticRenderFns } from "./StatenIsland.vue?vue&type=template&id=bf331d48&scoped=true"
import script from "./StatenIsland.vue?vue&type=script&lang=js"
export * from "./StatenIsland.vue?vue&type=script&lang=js"
import style0 from "./StatenIsland.vue?vue&type=style&index=0&id=bf331d48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf331d48",
  null
  
)

export default component.exports